import { defineSaleProgress, hasAddress, isSaleCreated, type ProgressSaleData } from '../saleProgress'

interface LeadEnergyProPlaceDesEnergiesData extends ProgressSaleData {
  leadType?: string | null
}

const TIMELINE = 'additionalSales:pulse.timeline.'

export default defineSaleProgress<LeadEnergyProPlaceDesEnergiesData>({
  kind: 'lead',
  steps: [
    { key: 'address', label: `${TIMELINE}address`, done: hasAddress },
    { key: 'qualified', label: `${TIMELINE}qualified`, done: data => !!data.leadType },
    { key: 'created', label: `${TIMELINE}lead_created`, done: isSaleCreated },
  ],
  status: (data, steps) => {
    if (steps[steps.length - 1].state === 'done') return 'signed'
    const isInProgress = hasAddress(data) || steps.some(step => step.state === 'done') || !!data.actionsInProgress
    if (isInProgress) return 'progress'

    return 'new'
  },
})
